module.exports = __webpack_public_path__ + "img/timetable_mobile.77b4302e.png";